// opervex-frontend/src/constants/filters.js

export const LOGIC_OPERATORS = [
  { label: "E", value: "AND" },
  { label: "OU", value: "OR" },
];

const COMPARISON_OPTIONS = [
  { value: "=", label: "Igual" },
  { value: "<>", label: "Diferente" },
  { value: ">", label: "Maior" },
  { value: ">=", label: "Maior Igual" },
  { value: "<", label: "Menor" },
  { value: "<=", label: "Menor Igual" },
];

const STRING_OPTIONS = [
  { value: "equal", label: "Igual" },
  { value: "different", label: "Diferente" },
  { value: "contain", label: "Contém" },
  { value: "notContain", label: "Não contém" },
  { value: "startWith", label: "Inicia com" },
  { value: "endWith", label: "Termina com" },
];

const BOOLEAN_OPTIONS = [{ value: "=", label: "Igual" }];

export const FILTER_OPTIONS = {
  number: COMPARISON_OPTIONS,
  integer: COMPARISON_OPTIONS,
  decimal: COMPARISON_OPTIONS,
  currency: COMPARISON_OPTIONS,
  date: COMPARISON_OPTIONS,
  dateOnly: COMPARISON_OPTIONS,

  string: STRING_OPTIONS,

  boolean: BOOLEAN_OPTIONS,
};
